<script setup lang="ts">
import type { PropType } from "vue";
import type { Collection } from "~/types";

const props = defineProps({
  collection: {
    type: Object as PropType<Collection>,
    required: true,
  },
});

const collectionToIterate = computed(() => {
  if (props.collection?.collection_collection?.length) {
    return props.collection?.collection_collection;
  }
  return props.collection?.collection_video;
});

const tabTitle = computed(() => {
  if (props.collection?.collection_collection?.length) {
    if (props.collection.non_primary_collection) {
      return "Weeks";
    } else {
      return "Seasons";
    }
  }
  return "Episodes";
});
</script>

<template>
  <div>
    <div
      class="before-b-border relative mb-5 border-b border-b-white pb-3 text-lg font-bold"
    >
      {{ tabTitle }}
    </div>
    <div class="grid grid-cols-2 gap-5 lg:grid-cols-4">
      <OnDemandCard
        v-for="(item, index) in collectionToIterate"
        :key="index"
        :item="item"
      />
    </div>
  </div>
</template>

<style scoped>
.before-b-border::before {
  content: "";
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 100px;
  height: 5px;
  background-color: var(--p-primary-200);
}
</style>
